export default {
  namespaced: true,
  state: {
    //设备模版显示控制
    groupIndex: -1
  },
  mutations: {
    upDateGroup (state, index) {
      state.groupIndex = index
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/equipment.js